import Axios from "../util/axiosInstance";

export const GetPreviouslyHiredTalent = (payload, config = {}) => {
  return Axios.post("/api/Company/GetHiredProjectTalent", payload, config);
};

export const GetUnfilterdSkills = () => {
  return Axios.get("/api/Skill/GetAllUnfiltered");
}

export const GetTalentPool = (payload, config = {}) => {
  return Axios.post("/api/Company/GetTalentPool", payload, config);
}

export const GetTalentSuggestionReason = (payload, config = {}) => {
  return Axios.post("/api/Company/GetTalentSuggestionReason", payload, config);
}